/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Org_TypeInputs */

const th_org_type = /** @type {(inputs: Org_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ประเภท`)
};

const en_org_type = /** @type {(inputs: Org_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Type`)
};

const ja_org_type = /** @type {(inputs: Org_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`種別`)
};

const zh_org_type = /** @type {(inputs: Org_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`类型`)
};

const es_org_type = /** @type {(inputs: Org_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tipo`)
};

const pt_org_type = /** @type {(inputs: Org_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tipo`)
};

const id_org_type = /** @type {(inputs: Org_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jenis`)
};

const fr_org_type = /** @type {(inputs: Org_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Type`)
};

const tl_org_type = /** @type {(inputs: Org_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uri`)
};

const vi_org_type = /** @type {(inputs: Org_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loại`)
};

const ko_org_type = /** @type {(inputs: Org_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`유형`)
};

const de_org_type = /** @type {(inputs: Org_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Typ`)
};

const ru_org_type = /** @type {(inputs: Org_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Тип`)
};

const tr_org_type = /** @type {(inputs: Org_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tür`)
};

const it_org_type = /** @type {(inputs: Org_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tipo`)
};

const pl_org_type = /** @type {(inputs: Org_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Typ`)
};

const uk_org_type = /** @type {(inputs: Org_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Тип`)
};

const hi_org_type = /** @type {(inputs: Org_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रकार`)
};

const ar_org_type = /** @type {(inputs: Org_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`النوع`)
};

const ms_org_type = /** @type {(inputs: Org_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jenis`)
};

const bn_org_type = /** @type {(inputs: Org_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ধরন`)
};

const zh_tw2_org_type = /** @type {(inputs: Org_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`類型`)
};

const zh_hk2_org_type = /** @type {(inputs: Org_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`類型`)
};

const ur_org_type = /** @type {(inputs: Org_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`قسم`)
};

const fa_org_type = /** @type {(inputs: Org_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`گونه`)
};

const sw_org_type = /** @type {(inputs: Org_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aina`)
};

const nl_org_type = /** @type {(inputs: Org_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Soort`)
};

/**
* | output |
* | --- |
* | "Type" |
*
* @param {Org_TypeInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const org_type = /** @type {((inputs?: Org_TypeInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Org_TypeInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_org_type(inputs)
	if (locale === "ja") return ja_org_type(inputs)
	if (locale === "zh") return zh_org_type(inputs)
	if (locale === "es") return es_org_type(inputs)
	if (locale === "pt") return pt_org_type(inputs)
	if (locale === "id") return id_org_type(inputs)
	if (locale === "fr") return fr_org_type(inputs)
	if (locale === "tl") return tl_org_type(inputs)
	if (locale === "vi") return vi_org_type(inputs)
	if (locale === "ko") return ko_org_type(inputs)
	if (locale === "de") return de_org_type(inputs)
	if (locale === "ru") return ru_org_type(inputs)
	if (locale === "tr") return tr_org_type(inputs)
	if (locale === "it") return it_org_type(inputs)
	if (locale === "pl") return pl_org_type(inputs)
	if (locale === "uk") return uk_org_type(inputs)
	if (locale === "hi") return hi_org_type(inputs)
	if (locale === "ar") return ar_org_type(inputs)
	if (locale === "ms") return ms_org_type(inputs)
	if (locale === "bn") return bn_org_type(inputs)
	if (locale === "zh-TW") return zh_tw2_org_type(inputs)
	if (locale === "zh-HK") return zh_hk2_org_type(inputs)
	if (locale === "ur") return ur_org_type(inputs)
	if (locale === "fa") return fa_org_type(inputs)
	if (locale === "sw") return sw_org_type(inputs)
	if (locale === "nl") return nl_org_type(inputs)
	return en_org_type(inputs)
});